import { LegalPageDto } from '../generated-types/legalPageDto';
import { AbstractApi } from './AbstractApi';

/**
 * An API to handle legal pages requests.
 */
export default class LegalPagesApi extends AbstractApi {
  /**
   * Get the specified legal page
   * @param pageId The id of the page to retrieve
   * @returns The legal page dto
   */
  async GetLegalPage(pageId: string): Promise<LegalPageDto> {
    const response = await fetch(this.BuildUrl(`legal-pages/${pageId}`), {
      method: 'GET',
    });

    if (!response.ok) throw Error();

    const responseText = await response.text();
    const legalPage = JSON.parse(responseText, (key, value) => {
      if (key === 'lastUpdated') {
        return new Date(value);
      }
      return value;
    });

    return legalPage;
  }
}
